"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddNewReviewees = exports.AddNewReviweesProvider = void 0;
const react_1 = __importStar(require("react"));
const immer_1 = __importDefault(require("immer"));
const zustand_1 = require("zustand");
const helper_1 = require("./helper");
const createRevieweeStore = () => {
    const initalPayloadBody = {
        includes: [],
        excludes: [],
        selectAll: false,
        assignmentEndsAt: '',
        notifyNewReviewee: false,
        emailStakeholders: ''
    };
    return (0, zustand_1.createStore)()((set, get) => ({
        cycleData: {},
        payloadBody: initalPayloadBody,
        isToggleNotificationStakeholdersOn: false,
        setCycleData: (cycleData) => set({ cycleData }),
        handleChangeState: (newState) => {
            set((currentState) => (0, immer_1.default)(currentState, newState));
        },
        getFormattedEmailStakeholders: () => (0, helper_1.getFormattedEmailStakeholders)(get),
        getFormatedPayloadBody: () => (0, helper_1.getFormatedPayloadBody)(get),
        checkIsEmailValid: () => (0, helper_1.checkIsEmailValid)(get),
        toggleNotificationStakeholders: () => {
            set((state) => ({
                isToggleNotificationStakeholdersOn: !state.isToggleNotificationStakeholdersOn
            }));
        }
    }));
};
const AddNewReviweesContext = (0, react_1.createContext)(null);
function AddNewReviweesProvider({ children }) {
    const storeRef = (0, react_1.useRef)();
    if (!storeRef.current) {
        storeRef.current = createRevieweeStore();
    }
    return (react_1.default.createElement(AddNewReviweesContext.Provider, { value: storeRef.current }, children));
}
exports.AddNewReviweesProvider = AddNewReviweesProvider;
function useAddNewReviewees(selector, equalityFn) {
    const store = (0, react_1.useContext)(AddNewReviweesContext);
    if (!store)
        throw new Error('Missing AddNewReviweesProvider in the tree');
    return (0, zustand_1.useStore)(store, selector, equalityFn);
}
exports.useAddNewReviewees = useAddNewReviewees;
